import { render, staticRenderFns } from "./PatchSidebar.vue?vue&type=template&id=96fcfab0&scoped=true&"
import script from "./PatchSidebar.vue?vue&type=script&lang=js&"
export * from "./PatchSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PatchSidebar.vue?vue&type=style&index=0&id=96fcfab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fcfab0",
  null
  
)

export default component.exports